import React from "react";
import { type Canvas } from "../../store/storyline/types";
import CanvasDebugger from "../../developer/CanvasDebugger/CanvasDebugger";
import { AppThemeProvider } from "../../shared/providers/AppThemeProvider";
import PopoutWindow from "../../shared/components/PopoutWindow";

const DEV_WINDOW_FEATURES = { width: 1440, height: 900 };

type DevWindowProps = {
    slide: Canvas;
    frameData: object;
    setDevWindowIsClosed: () => void;
}

export const DevWindow: React.FC<DevWindowProps> = React.memo(({ slide, frameData, setDevWindowIsClosed}) => (
    <PopoutWindow onUnload={setDevWindowIsClosed} url="" title="Canvas Debugger" features={DEV_WINDOW_FEATURES}>
        <AppThemeProvider>
            <CanvasDebugger slide={slide} frameData={frameData} />
        </AppThemeProvider>
    </PopoutWindow>
));